import { Component, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderService } from './loader.service';

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div *ngIf="loading()" class="overlay">
      <!-- Bar Loader -->
      <div class="bar-loader">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  `,
  styles: [
    `
      .overlay {
        position: fixed;
        inset: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(0, 0, 0, 0.5);
        z-index: 9999;
      }

      .bar-loader {
        display: flex;
        gap: 0.5rem;
      }

      .bar-loader div {
        width: 15px;
        height: 70px;
        background: #05143f;
        animation: bounce 1s infinite ease-in-out;
      }

      .bar-loader div:nth-child(2) {
        animation-delay: 0.2s;
      }

      .bar-loader div:nth-child(3) {
        animation-delay: 0.4s;
      }

      @keyframes bounce {
        0%,
        80%,
        100% {
          transform: scaleY(0.4);
        }
        40% {
          transform: scaleY(1);
        }
      }
    `,
  ],
})
export class LoaderComponent {
  loading = computed(() => this.loaderService.loading());
  constructor(private loaderService: LoaderService) {}
}
